<template>
  <DropDownFilter
    :menuSections="dropDownMenuSections"
    :setLoadingOverlay="setLoadingOverlay"
    :storeModule="ospPolicyCollection"
  />
</template>

<script>
import {
  DropDownSectionConsts, ItemTypeConsts, PolicyConsts, StoreModuleMap,
} from
  'client/util/Constants';
import { mapActions } from 'vuex';
import DropDownFilter from 'client/components/ItemTable/CollectionFilterComponents/DropDownFilter.vue';
import DropDownFilterMixin from 'client/components/ItemTable/mixins/DropDownFilterMixin';

const {
  selectOne,
} = DropDownSectionConsts;

const {
  mac,
  windows,
  linux,
} = PolicyConsts.policyTemplateTypes;

const ospPolicyCollection = StoreModuleMap[ItemTypeConsts.osPatchManagement];

export default {
  name: 'OsPolicyDropDownFilter',

  components: {
    DropDownFilter,
  },

  mixins: [
    DropDownFilterMixin,
  ],

  data() {
    const filters = {
      os: os => ({
        name: 'template.osMetaFamily',
        operator: 'eq',
        value: os,
        type: 'OS',
        displayValue: os,
      }),
    };

    const menuItems = [
      { os: mac, label: 'Mac' },
      { os: windows, label: 'Windows' },
      { os: linux, label: 'Linux' },
    ].map(({ os, label }) => ({
      action: () => this.handleDropDownAction(filters.os(os)),
      filter: filters.os(os),
      label,
    }));

    return {
      dropDownMenuSections: [
        {
          menuLabel: 'device OS:',
          menuType: selectOne,
          menuItems,
        },
      ],
      filters,
      ospPolicyCollection,
    };
  },

  methods: {
    ...mapActions(ospPolicyCollection, [
      'setFilter',
      'fetchCollection',
    ]),
  },
};
</script>
